module.exports = __webpack_public_path__ + "img/tmx_store_samsung_s_drive_budaors_small.36edde27.jpg";